import { baseApi } from 'utils/apiUtil';
import { http } from 'utils/httpUtil';
import PlansForDate from 'modules/effectiveDate/types';

const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

const isPlan = (plan: unknown) =>
  isObject(plan) &&
  typeof plan.planId === 'string' &&
  (plan.masterId == null || typeof plan.masterId === 'string');

const isLine = (line: unknown) =>
  isObject(line) &&
  typeof line.benefitKind === 'string' &&
  Array.isArray(line.plans) &&
  line.plans.every(isPlan);

// A 200 whose plans carry no ids would read as "every held plan is inactive",
// so a body that is not the contract is an error, never an answer.
const isPlansForDate = (body: unknown): body is PlansForDate =>
  isObject(body) && Array.isArray(body.lines) && body.lines.every(isLine);

// Without `benefit-kinds` the server answers for every line the employer has
// plans on, so nothing is sent for it unless the caller names lines.
export const getPlansForDate = async (
  employerId: string,
  date: string,
  benefitKinds?: string[]
) => {
  const response = await http.get<PlansForDate>(
    `${baseApi}/v1/plans/for-date/employers/${employerId}`,
    {
      params: {
        date,
        ...(benefitKinds?.length
          ? { 'benefit-kinds': benefitKinds.join(',') }
          : {}),
      },
    }
  );
  if (!isPlansForDate(response.data)) {
    throw new Error('Plans-for-date answer does not match the contract');
  }
  return response;
};
